module.exports = __webpack_public_path__ + "static/img/749da61cb19049b7313a5f0abd7e2f7f.70414235.webp";